import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesDetailSection from '../components/ServicesDetailSection';
import QuoteFormSection from '../components/QuoteFormSection';
import FeaturedProjectsSection from '../components/FeaturedProjectsSection';
import ProjectGallerySection from '../components/ProjectGallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import CallToActionSection from '../components/CallToActionSection';
import Footer from '../components/Footer';
export function HomePage() {
  return <>
      <div id="hero" data-id="element-622">
        <HeroSection data-id="element-623" />
      </div>
      <div id="about" data-id="element-624">
        <AboutSection data-id="element-625" />
      </div>
      <div id="services" data-id="element-626">
        <ServicesDetailSection data-id="element-627" />
      </div>
      <div id="work" data-id="element-628">
        <ProjectGallerySection data-id="element-629" />
      </div>
      <div id="contact" data-id="element-630">
        <QuoteFormSection data-id="element-631" />
      </div>
      <FeaturedProjectsSection data-id="element-632" />
      <div id="testimonials" data-id="element-633">
        <TestimonialsSection data-id="element-634" />
      </div>
      <WhyChooseUsSection data-id="element-635" />
      <CallToActionSection data-id="element-636" />
      <Footer data-id="element-637" />
    </>;
}